export default __webpack_public_path__ + "static/media/archivo.5111f047.png";